import i18n from '@/i18n'

export const STATUS_COLORS = {
  normal:   '#34d399',
  caution:  '#fbbf24',
  abnormal: '#f87171',
  delay:    '#6b7280',
}

// 상태 텍스트는 이제 i18n 에서 lookup — 활성 locale 에 따라 변경
//   STATUS_TEXT 객체는 후방 호환을 위해 getter 로 유지 (변경된 locale 자동 반영)
const STATUS_KEYS = {
  normal:   'dashboard.summary.normal',
  caution:  'dashboard.summary.caution',
  abnormal: 'dashboard.summary.alarm',
  delay:    'dashboard.summary.delay',
}
export const STATUS_TEXT = new Proxy({}, {
  get(_, key) {
    const k = STATUS_KEYS[key]
    return k ? i18n.global.t(k) : key
  },
})

export const STATUS_ORDER = {
  delay:    0,
  normal:   1,
  caution:  2,
  abnormal: 3,
}

function pressureStatus(d) {
  if (d.mnp == null || d.mnp === '') return 'delay'
  if (d.content != null && d.content !== '') return 'abnormal'
  const boundary = Number(d.ref_mnp_boundary ?? d.mnp_boundary)
  const mnp = Number(d.mnp)
  if (isFinite(boundary) && isFinite(mnp)) {
    if (mnp < boundary || mnp >= boundary + 2) return 'caution'
  }
  return 'normal'
}

function leakStatus(d) {
  if (d.wave_energy == null) return 'delay'
  if (typeof d._5days === 'string' && d._5days.slice(0, 5) === '1,1,1') return 'abnormal'
  if (d.ai_leak_result === 'L') return 'caution'
  return 'normal'
}

export function getDeviceStatus(d) {
  if (!d) return 'delay'
  if (d.measure_type === 'leak') return leakStatus(d)
  return pressureStatus(d)
}

export function statusColor(st) { return STATUS_COLORS[st] || STATUS_COLORS.delay }
export function statusText(st)  { return STATUS_TEXT[st]   || st }
